module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-76x76.c12536572c12bea469c22f7a2d4da2bd.png";